export class ApplicationRole
{
    constructor (public application: string, public role: string)
    {

    }
}
